cb.define([], function () { // 编辑 新增 商品模板
  var PC_pc_producttpl_VM_Extend = {
    doAction: function (name, viewmodel) {
      if (this[name]) {
        this[name](viewmodel);
      }
    },
    init: function (viewmodel) {
      let UnitsModel = viewmodel.get('Units');
      const classIds = [
        'SpecSums',
        'PropertySums',
        'SKUPropertySums',
        'OrderPropertySums',
      ];
      classIds.forEach((v) => {
        viewmodel.get(v).getEditRowModel().get('order').setState('min', 0) // 判断 是否启动周期购
      })
      // 需要校验的字段
      let needrequire = {
        "PropertySums": ["isRequired", "isShow", "alias"],
        "SKUPropertySums": ["isRequired", "alias"],
        "OrderPropertySums": ["isRequired", "isShow", "alias"],
      }
      Object.keys(needrequire).forEach((v) => {
        let currentModel = viewmodel.get(v);
        currentModel.on('beforeCellValueChange', (args) => {
          let _this = this;
          if (needrequire[v].includes(args.cellName)) {
            let proxy = cb.rest.DynamicProxy.create({
              ensure: {
                url: "/product/tpl/refcheck",
                method: 'POST',
                options: { async: false },
              },
            });
            var params = {
              billnum: "pc_producttpl",
              id: viewmodel.get("id").getValue(),
            }
            let data = proxy.ensure(params);
            if (data.result.products && data.result.products > 0 && data.result[v]) {
              var promise = new cb.promise();
              cb.utils.confirm('属性已在商品档案中使用，修改时商品档案中的对应属性将一并修改，是否继续？', function () {
                promise.resolve()
              }, () => {
                currentModel.setCellValue(args.rowIndex, args.cellName, args.oldValue)
                promise.reject()
              })
              return promise
            }
          }
        })
      })
      const diffCyclePurchase = () => {
        let enableCyclePurchaseData = viewmodel.get('enableCyclePurchase').getData();
        let val = typeof enableCyclePurchaseData == 'boolean' ? enableCyclePurchaseData : (enableCyclePurchaseData == 'false' ? false : true)
        viewmodel.execute('updateViewMeta', {
          code: 'pc_producttpl_cycle_page_base',
          visible: val,
        });
        viewmodel.get('CycleProperties').setColumnState('values', 'bIsNull', true);
      }
      let jsonformatter = {
        "1": "y1",
        "2": "y2",
        "5": "y3",
        "6": "y4",
        "7": "y5",
        "8": "y6",
        "3": "y7",
        "4": "y8",
      }
      let _jsonformatter = {
        "y1": "1",
        "y2": "2",
        "y3": "5",
        "y4": "6",
        "y5": "7",
        "y6": "8",
        "y7": "3",
        "y8": "4",
      }
      // const clearbatchPriceUnit = (gridmodel) => {
      //   gridmodel.setCellValue(0, "batchPriceUnit", null);
      //   gridmodel.setCellValue(0, "batchPriceUnit_Name", null);
      //   gridmodel.setCellValue(0, "batchPriceRate", null);
      //   gridmodel.getEditRowModel().get("batchPriceRate").setDisabled(true);
      // }
      viewmodel.get('enableCyclePurchase').on('afterValueChange', () => {
        diffCyclePurchase();
      })
      const addParameter = (args) => {
        if (args.params.cParameter == 'param') {
          if (args.params.params && args.params.params.index >= 0) {
            let paramVm = viewmodel.get("Parameters");
            let rowData = {
              group: viewmodel.get("Parameters").getCellValue(args.params.params.index, "group"),
            };
            paramVm.insertRow(args.params.params.index + 1, rowData);
          }
          return false;
        }
        return true;
      }
      const checkReference = (callback) => {
        var proxy = cb.rest.DynamicProxy.create({
          ensure: {
            url: "/product/tpl/refcheck",
            method: "POST",
          },
        });
        var params = {
          billnum: "pc_producttpl",
          id: viewmodel.get("id").getValue(),
        }
        proxy.ensure(params, function (err, result) {
          callback(err, result)
        });
      }

      const hasRecord = (item, vals) => {
        if (!vals) {
          return false;
        }
        let items = vals.split('; ')
        for (var i in items) {
          if (items[i] == item) {
            return true
          }
        }
        return false;
      }

      const getRowById = (rows, id, fld) => {
        for (var i in rows) {
          if (rows[i][fld] == id) {
            return rows[i];
          }
        }
        return null;
      }

      const checkAddRow = (args, callback) => {
        let mode = viewmodel.getParams().mode;
        if (mode != "edit") {
          callback()
          return;
        }

        checkReference(function (err, result) {
          if (err) {
            cb.utils.alert(err.message, 'warning')
          } else {
            args.rows = args.rows || []
            if (args.entity == "SpecSums") {
              if (result.products && result.products > 0 && result.SpecSums) {
                // 如果已有商品引用，不允许新增或删除
                let removed = []
                for (var spec in result.SpecSums) {
                  let newRow = null;
                  for (var i in args.rows) {
                    let row = args.rows[i]
                    if (row.specification == spec) {
                      newRow = row
                      break
                    }
                  }
                  newRow = newRow || { specitem: '' }
                  let specVals = result.SpecSums[spec];
                  for (var item in specVals) {
                    if (specVals[item] && !hasRecord(item, newRow.specitem)) {
                      removed.push({ id: spec, item: item })
                    }
                  }
                }
                if (removed.length > 0) {
                  let msg = {}
                  for (var r in removed) {
                    let ritem = removed[r]
                    msg[ritem.id] = (msg[ritem.id] || '') + ritem.item + ','
                  }
                  let msgStr = '以下规格已被商品档案引用，不能删除：';
                  for (var spec in msg) {
                    let data = getRowById(args.data, spec, "specification")
                    let name = data["specification_showItem"]
                    msgStr += name + '[';
                    msgStr += msg[spec]
                    msgStr = msgStr.substring(0, msgStr.length - 1) + '] '
                  }
                  cb.utils.alert(msgStr, 'warning')
                } else {
                  // 检查是否有新增项
                  if (args.data.length < args.rows.length) {
                    cb.utils.alert('模板已被商品使用，不能增加规格项。', 'warning')
                  } else {
                    callback(args)
                  }
                }
              } else {
                callback(args)
              }
            } else {
              if (result.products && result.products > 0 && result[args.entity]) {
                let removed = []
                for (var prop in result[args.entity]) {
                  let newRow = null;
                  for (var i in args.rows) {
                    let row = args.rows[i]
                    if (row['propertyType'] == prop) {
                      newRow = row
                      break
                    }
                  }
                  let propVals = result[args.entity][prop];
                  if (propVals === true && !newRow) {
                    removed.push({ id: prop, item: '' })
                  } else if (propVals instanceof Object) {
                    newRow = newRow || { values: '' }
                    for (var item in propVals) {
                      if (propVals[item] && !hasRecord(item, newRow.values)) {
                        removed.push({ id: prop, item: item })
                      }
                    }
                  }
                }
                if (removed.length > 0) {
                  let msg = {}
                  for (var r in removed) {
                    let ritem = removed[r]
                    msg[ritem.id] = (msg[ritem.id] || '') + ritem.item + ','
                  }
                  let msgStr = '属性已在商品档案中使用，删除时商品档案中的对应属性将一并删除，是否继续？';
                  // for(var spec in msg){
                  //   let data = getRowById(args.data, spec, "propertyType")
                  //   let name = data["propertyType_showItem"]
                  //   msgStr += name + '[';
                  //   msgStr += msg[spec]
                  //   msgStr = msgStr.substring(0, msgStr.length - 1) + '] '
                  // }
                  cb.utils.confirm(msgStr, function () {
                    callback(args)
                  })
                } else {
                  callback(args)
                }
              } else {
                callback(args)
              }
            }
          }
        })
      }

      const replaceEnum = (model, column, value) => {
        let col = viewmodel.get(model).getColumn(column);
        if (!col.cEnumString) {
          return value;
        }
        let enumObj = JSON.parse(col.cEnumString);
        if (enumObj[value]) {
          return enumObj[value];
        }
        return value;
      }

      let viewmodelTag,
        tagData;
      // SpecSums
      viewmodel.on('beforeAddRow', function (args) {
        viewmodelTag = args.params.childrenField
        if (viewmodelTag == 'Parameters') {
          return addParameter(args);
        }
        if (classIds.indexOf(viewmodelTag) < 0) return true
        tagData = viewmodel.get(viewmodelTag).getData();
        // 需要判断页签
        viewmodel.communication({
          type: 'modal',
          payload: {
            key: 'Specifications',
            data: {
              model: viewmodel,
              data: tagData,
              childrenField: viewmodelTag,
            },
          },
        });
        return false
      });
      let ParametersModel = viewmodel.get('Parameters');
      ParametersModel.setState('showColumnSetting', false);
      ParametersModel.setState('mergeCells', true);
      ParametersModel.setColumnState("group", "bMergeCol", true);
      viewmodel.on('deleteParameter', function (args) {
        let paramVm = viewmodel.get("Parameters");
        let rows = []
        if (args.params && args.params.index >= 0) {
          if (args.cParameter == 'group') {
            let group = viewmodel.get("Parameters").getCellValue(args.params.index, "group");
            for (var i = 0; i < paramVm.getRows().length; i++) {
              if (group == paramVm.getCellValue(i, 'group')) {
                rows.push(i);
              }
            }
          } else {
            rows.push(args.params.index);
          }
        }
        if (rows.length > 0) {
          paramVm.deleteRows(rows);
        }
      });
      viewmodel.on('afterHandleOK', function (args) {
        if (args.key !== 'Specifications') return
        let newRows = []
        args.value.forEach((value, index) => {
          let recordList = value.recordList.filter(v => v.checked);
          let specitemList = [];
          let erpNameList = [];
          recordList.forEach((v) => {
            erpNameList.push(v.erpName);
            specitemList.push(v.name);
          })
          let rowData,
            order,
            alias,
            isShow,
            isRequired;
          switch (viewmodelTag) {
            case 'SpecSums': // 商品规格
              for (let i = 0, len = tagData.length; i < len; i++) {
                if (value.defineId == tagData[i].specification_defineId) {
                  order = tagData[i].order,
                  alias = tagData[i].alias
                  break;
                }
              }
              rowData = {
                specification_erpCode: value.erpCode,
                specification_showItem: value.showItem,
                erpName: erpNameList.join('; '),
                specitem: specitemList.join('; '),
                specification_defineId: value.defineId,
                specification: value.id,
                order: index + 1,
                alias: alias || value.alias,
              }
              break;
            case 'PropertySums': // 商品扩展属性
              for (let i = 0, len = tagData.length; i < len; i++) {
                if (value.defineId == tagData[i].propertyType_defineId) {
                  isRequired = tagData[i].isRequired,
                  isShow = tagData[i].isShow,
                  order = tagData[i].order,
                  alias = tagData[i].alias
                  break;
                }
              }
              rowData = {
                values: specitemList.join('; '),
                propertyType_showItem: value.showItem,
                propertyType_defineId: value.defineId,
                propertyType_type: replaceEnum(viewmodelTag, "propertyType_type", value.type),
                propertyType_userdefMode: replaceEnum(viewmodelTag, "propertyType_userdefMode", value.userdefMode),
                propertyType: value.id,
                isRequired: isRequired || value.isSerInput || false,
                isShow: isShow || value.isWebShow || false,
                order: order || value.orderNum,
                alias: alias || value.userdefAlias,
              }
              break;
            case 'SKUPropertySums': // 商品订单属性
              for (let i = 0, len = tagData.length; i < len; i++) {
                if (value.defineId == tagData[i].propertyType_defineId) {
                  isRequired = tagData[i].isRequired,
                  order = tagData[i].order,
                  alias = tagData[i].alias
                  break;
                }
              }
              rowData = {
                values: specitemList.join('; '),
                propertyType_showItem: value.showItem,
                propertyType_defineId: value.defineId,
                propertyType_type: replaceEnum(viewmodelTag, "propertyType_type", value.type),
                propertyType_userdefMode: replaceEnum(viewmodelTag, "propertyType_userdefMode", value.userdefMode),
                propertyType: value.id,
                isRequired: isRequired || value.isSerInput || false,
                order: order || value.orderNum,
                alias: alias || value.userdefAlias,
              }
              break;
            case 'OrderPropertySums': // 商品订单属性
              let limitNum,
                values,
                propertyType_maxInputLen,
                propertyType_decimalDigits = null;
              for (let i = 0, len = tagData.length; i < len; i++) {
                if (value.defineId == tagData[i].propertyType_defineId) {
                  isRequired = tagData[i].isRequired
                  isShow = tagData[i].isShow
                  order = tagData[i].order
                  limitNum = tagData[i].limitNum
                  alias = tagData[i].alias
                  values = tagData[i].values
                  propertyType_decimalDigits = tagData[i].decimalDigits
                  propertyType_maxInputLen = tagData[i].maxInputLen
                  break;
                }
              }
              rowData = {
                values: value.userdefMode == 3 ? values : specitemList.join('; '),
                propertyType_showItem: value.showItem,
                propertyType_defineId: value.defineId,
                propertyType_type: replaceEnum(viewmodelTag, "propertyType_type", value.type),
                propertyType_maxInputLen: propertyType_maxInputLen || value.maxInputLen,
                propertyType_decimalDigits: propertyType_decimalDigits || value.decimalDigits,
                propertyType_userdefMode: replaceEnum(viewmodelTag, "propertyType_userdefMode", value.userdefMode),
                propertyType: value.id,
                isShow: isShow || value.isWebShow || false,
                isRequired: isRequired || value.isWebInput || false,
                order: order || value.orderNum,
                limitNum: limitNum || value.limitNum,
                alias: alias || value.userdefAlias,
              }
              break;
            default:
          }
          newRows.push(rowData)
        })

        checkAddRow({
          entity: viewmodelTag,
          rows: newRows,
          data: tagData,
        }, function () {
          let gridModel = viewmodel.get(viewmodelTag);
          gridModel.clear();
          for (var r in newRows) {
            let row = newRows[r]
            if (viewmodelTag == "SpecSums" && (!row.specitem || row.specitem == '')) {
              cb.utils.alert('已忽略无可用规格值的规格项：' + row['specification_showItem']);
              continue;
            } else if (row['propertyType_userdefMode'] == "选择项" && (!row.values || row.values == '')) {
              cb.utils.alert('已忽略无可用属性值的选择项属性：' + row['propertyType_showItem']);
              continue;
            }
            gridModel.appendRow(newRows[r])
          }
          for (let i = 0; i < gridModel.getRows().length; i++) {
            gridModel.setCellState(i, "values", "disabled", gridModel.getCellValue(i, "propertyType_userdefMode") != 2)
          }
        })
      });
      const MeasurementArr = {
        purchaseUnit_Name: 'purchaseRate', // 采购单位
        stockUnit_Name: 'stockRate', // 库存单位
        batchUnit_Name: 'batchRate', // 批发单位
        onlineUnit_Name: 'onlineRate', // 线上零售单位
        offlineUnit_Name: 'offlineRate', // 线下零售单位
        requireUnit_Name: 'requireRate', // 要货单位
        batchPriceUnit_Name: 'batchPriceRate', // 批发报价单位
      }
      const diffMeasurementArr = () => {
        Object.keys(MeasurementArr).forEach((key) => {
          diffUnit(key)
        })
      }
      // 比较计量单位 与 主计量单位  对应的单位换算率
      const diffUnit = (key) => {
        let _mainval = UnitsModel.getCellValue(0, 'unit_Name');
        let _keyval = UnitsModel.getCellValue(0, key);
        if (!_keyval) {
          UnitsModel.setCellValue(0, MeasurementArr[key], null)
          UnitsModel.getEditRowModel().get(MeasurementArr[key]).setDisabled(true);
          return false
        }
        if (_keyval == _mainval) {
          UnitsModel.setCellValue(0, MeasurementArr[key], 1)
          UnitsModel.getEditRowModel().get(MeasurementArr[key]).setDisabled(true);
        } else {
          UnitsModel.getEditRowModel().get(MeasurementArr[key]).setDisabled(false);
        }
      }
      Object.values(MeasurementArr).forEach((val) => {
        UnitsModel.getEditRowModel().get(val).setState("min", 0);
        // UnitsModel.getEditRowModel().get(val).setState("max", 99);
      })
      // UnitsModel.on('beforeCellValueChange', (args) => {
      //   let unit = UnitsModel.getCellValue(0, "unit");
      //   if (args.cellName == 'batchPriceUnit_Name') {
      //     if (!args.value.name) {
      //       return true
      //     }
      //     let batchUnit = UnitsModel.getCellValue(0, "batchUnit")
      //     if (args.value.id !== unit && args.value.id !== batchUnit) {
      //       cb.utils.alert('批发报价单位只能从主计量单位和批发单位 里选', 'warning');
      //       return false
      //     }
      //   }
      // })
      UnitsModel.on('afterCellValueChange', (args) => {
        let unit = UnitsModel.getCellValue(0, "unit");
        switch (args.cellName) {
          case 'unit_Name':
            let _mainid = args.value.id;
            let _mainval = args.value.name;
            let _isEmpty = false;
            Object.keys(MeasurementArr).forEach((v) => {
              _isEmpty = _isEmpty || !!UnitsModel.getCellValue(0, v);
            })
            if (!_isEmpty) {
              Object.keys(MeasurementArr).forEach((v) => {
                UnitsModel.setCellValue(0, v, _mainval)
                UnitsModel.setCellValue(0, v.match(/(\S*)_Name/)[1], _mainid)
              })
            }
            UnitsModel.setCellValue(0, 'offlineUnit_Name', _mainval)
            UnitsModel.setCellValue(0, 'offlineUnit', _mainid)
            diffMeasurementArr()
            break;
          default:
            diffUnit(args.cellName);
        }
      })
      let CyclePropertiesModel = viewmodel.get("CycleProperties");
      CyclePropertiesModel.on("beforeBrowse", function (data) {
        if (data && data.cellName == "source_name") { // 来源分组过滤
          data.context.setCondition({ "group": "cycle" });
        }
      });
      // ------------------------周期购------------------------
      const _values = {
        '1': '30|60|90',
        '2': '2|3|4|5|6',
        '3': '2|3|4|5|6',
      }
      CyclePropertiesModel.setColumnState('values', 'formatter', (rowInfo, rowData) => {
        if (rowInfo.rowIndex === 0) {
          return {
            formatterKey: 'purchaseCycle',
            props: {
              mode: viewmodel.getParams().mode,
              values: rowData.values || '1',
              handleChange: (data) => {
                CyclePropertiesModel.setCellValue(rowInfo.rowIndex, 'values', data)
                CyclePropertiesModel.setCellValue(4, 'values', '')
                diffFrequency(data)
              },
            },
          }
        } else if (rowInfo.rowIndex === 4) {
          return {
            formatterKey: 'DistributionFrequency',
            props: {
              mode: viewmodel.getParams().mode,
              values: rowData.values,
              handleChange: (data) => {
                CyclePropertiesModel.setCellValue(rowInfo.rowIndex, 'values', data.join('|'))
              },
            },
          }
        } else if (rowInfo.rowIndex === 5) {
          return {
            formatterKey: 'MiniTime',
            props: {
              mode: viewmodel.getParams().mode,
              values: rowData.values,
              handleChange: (data) => {
                CyclePropertiesModel.setCellValue(rowInfo.rowIndex, 'values', data)
              },
            },
          }
        }
      })
      CyclePropertiesModel.on('afterCellValueChange', (args) => {
        if ('values' == args.cellName) {
          if (args.rowIndex == 1 || args.rowIndex == 2) {
            let _valueArr = (args.value || '').split('|');
            let isTrue = false;
            _valueArr.length && _valueArr.forEach((val) => {
              isTrue = isTrue || !(val == Number(val))
            })
            if (isTrue) {
              cb.utils.alert('请输入正确的属性值', 'warning');
              CyclePropertiesModel.setCellValue(args.rowIndex, 'values', args.oldValue)
            }
          }
        }
        if (args.cellName == 'showType') {
          let val = !Number(args.value.value) // 0 输入项
          args.rowIndex !== 5 && CyclePropertiesModel.setCellState(args.rowIndex, "values", "disabled", val)
          var firstValue = CyclePropertiesModel.getCellValue(0, 'values') || '1' // 找到第一个values的值
          if (args.rowIndex == 1) {
            CyclePropertiesModel.setCellValue(args.rowIndex, 'values', (val ? '输入项不可输入' : _values[firstValue]))
          } else if (args.rowIndex == 2) {
            CyclePropertiesModel.setCellValue(args.rowIndex, 'values', (val ? '输入项不可输入' : '1|2|3|4|5'))
          } else if (args.rowIndex == 5) {
            CyclePropertiesModel.setCellState(args.rowIndex, "values", "disabled", !val)
            CyclePropertiesModel.setCellValue(args.rowIndex, 'values', (!val ? '选择项不可输入' : ''))
          }
        }
      })
      const diffValues = () => { // 根据表现类型的值 定义 属性值的显示 与 可不可选
        let CyclePropertiesData = CyclePropertiesModel.getData();
        CyclePropertiesData.forEach((val, index) => {
          let _val = !Number(val.showType) // 0 输入项
          if (index === 5) {
            CyclePropertiesModel.setCellState(5, "values", "disabled", !_val)
            CyclePropertiesModel.setCellValue(5, 'values', (!_val ? '选择项不可输入' : val.values))
            CyclePropertiesModel.setCellState(5, "values", "after", '小时')
            return
          }
          if (_val) {
            CyclePropertiesModel.setCellState(index, "values", "disabled", true)
            CyclePropertiesModel.setCellValue(index, 'values', '输入项不可输入')
          }
        })
      }
      // 根据频次判断哪个显示
      const diffFrequency = (data) => {
        if (!data) {
          data = CyclePropertiesModel.getCellValue(0, 'values')
        } else {
          isType(data)
        }
        switch (data) {
          case '2':
            CyclePropertiesModel.setCellValue(4, 'propertyType_name', '每周配送日')
            CyclePropertiesModel.setCellValue(4, 'alias', '每周配送日')
            CyclePropertiesModel.setCellValue(4, 'propertyType', '6')
            break;
          case '3':
            CyclePropertiesModel.setCellValue(4, 'propertyType_name', '每月配送日')
            CyclePropertiesModel.setCellValue(4, 'alias', '每月配送日')
            CyclePropertiesModel.setCellValue(4, 'propertyType', '7')
            break;
          default: // 默认是1
            CyclePropertiesModel.setCellValue(4, 'propertyType_name', '按日配送频次');
            CyclePropertiesModel.setCellValue(4, 'alias', '按日配送频次');
            CyclePropertiesModel.setCellValue(4, 'propertyType', '5');
            let CycleProperties_values4 = CyclePropertiesModel.getCellValue(4, 'values');
            CyclePropertiesModel.setCellValue(4, 'values', CycleProperties_values4.split('|').map(val => jsonformatter[val]).join('|'));
            CyclePropertiesModel.doPropertyChange("handleFocus")
        }
      }
      const isType = (data) => {
        let showTypeVal = CyclePropertiesModel.getCellValue(1, 'showType')
        if (!Number(showTypeVal)) {
          CyclePropertiesModel.setCellValue(1, "values", '输入项不可输入')
          CyclePropertiesModel.setCellState(1, "values", "disabled", true)
        } else {
          CyclePropertiesModel.setCellValue(1, "values", _values[data])
          CyclePropertiesModel.setCellState(1, "values", "disabled", false)
        }
      }
      // 初始状态隐藏
      viewmodel.on('afterLoadData', function () {
        let unit = UnitsModel.getCellValue(0, "unit");
        let unit_Name = UnitsModel.getCellValue(0, "unit_Name");
        UnitsModel.getEditRowModel().get('offlineUnit_Name').setDisabled(true);
        UnitsModel.getEditRowModel().get('offlineUnit').setValue(unit);
        UnitsModel.getEditRowModel().get('offlineUnit_Name').setValue(unit_Name);
        diffCyclePurchase();
        if (viewmodel.get("Units")) {
          viewmodel.get("Units").setFocusedRowIndex(0);
          Object.keys(MeasurementArr).forEach((key) => {
            diffUnit(key)
          })
        }
        var mode = viewmodel.getParams().mode;
        if (mode == 'edit' || mode == 'add') {
          let orderModel = viewmodel.get("OrderPropertySums");
          if (orderModel) {
            for (let i = 0; i < orderModel.getRows().length; i++) {
              orderModel.setCellState(i, "values", "disabled", orderModel.getCellValue(i, "propertyType_userdefMode") != 2)
            }
          }
        }
        // --------------------------------------周期购-------------------------------
        diffFrequency(); //
        [0, 3, 4].forEach((val) => {
          if (val != 3) {
            CyclePropertiesModel.setCellValue(val, 'showType', '1'); // 选择项
          } else {
            CyclePropertiesModel.setCellValue(3, 'showType', '0'); // 输入项
          }
          CyclePropertiesModel.setCellState(val, "showType", "disabled", true);
        })
        CyclePropertiesModel.setCellState(5, "showType", "disabled", true);
        diffValues();
      })
      // 周期购保存
      viewmodel.on('beforeSave', function (args) {
        let data = JSON.parse(args.data.data);
        let enableCyclePurchaseData = viewmodel.get('enableCyclePurchase').getData();
        let val = typeof enableCyclePurchaseData == 'boolean' ? enableCyclePurchaseData : (enableCyclePurchaseData == 'false' ? false : true)
        if (!val) { // 不启用周期购 周期购保存 之前的数据
          delete data.CycleProperties
        } else {
          let _CycleData = CyclePropertiesModel.getCellValue(4, 'values')
          if (!_CycleData) {
            cb.utils.alert('请选择周期购配送频次', 'warning');
            return false
          }
          if (!data.CycleProperties[0].values) {
            data.CycleProperties[0].values = '1'
          }
          if (data.CycleProperties[0].values === '1') {
            // 按日 配送频次
            let frequency_index = data.CycleProperties.findIndex(v => v.propertyType === "5");
            if (frequency_index > -1) {
              let CycleProperties_values4 = data.CycleProperties[frequency_index].values;
              data.CycleProperties[frequency_index].values = CycleProperties_values4.split('|').map(val => _jsonformatter[val]).join('|');
            }
          }
        }
        classIds.forEach((v) => {
          data[v] = viewmodel.get(v).getData();
          if (data[v] && data[v].length) {
            for (let i = 0; i < data[v].length; i++) {
              if (data[v][i]._status == 'Delete') {
                data[v].splice(i, 1)
                i--;
              } else {
                data[v][i]._status = 'Insert'
              }
            }
          }
        })
        let mode = viewmodel.getParams().mode;
        if (mode == 'add') { // fixed 模板保存时候 id没有值的bug
          let Units = data.Units[0]
          Object.keys(MeasurementArr).forEach((key) => {
            let id = key.replace('_Name', '');
            if (Units[key] && !Units[id]) {
              Units[id] = Units['unit']
            }
          })
          data.Units[0] = Units
        }
        args.data.data = JSON.stringify(data);
      })
      // 编辑行内容
      viewmodel.on('editRow', (args) => {
        viewmodelTag = args.childrenField;
        tagData = viewmodel.get(viewmodelTag).getData();
        viewmodel.communication({
          type: 'modal',
          payload: {
            key: 'Specifications',
            data: {
              model: viewmodel,
              data: tagData,
              childrenField: args.childrenField,
              index: args.params.index,
            },
          },
        });
      })
      viewmodel.on('beforeDeleteRow', function (args) {
        let mode = viewmodel.getParams().mode;
        let entity = args.params.childrenField;
        if (mode != "edit" || (entity != "SpecSums" && entity != "PropertySums" && entity != "SKUPropertySums" && entity != "OrderPropertySums")) {
          return true;
        }
        let grid = viewmodel.getGridModel(entity)
        let params = { entity: entity, rows: [] }
        params.data = grid.getRows()
        for (var r in params.data) {
          if (r != args.params.params.index) {
            params.rows.push(params.data[r])
          }
        }
        checkAddRow(params, function () {
          viewmodel.getGridModel(entity).deleteRows(args.params.params.index)
        })
        return false;
      })
    },
  }
  try {
    module.exports = PC_pc_producttpl_VM_Extend;
  } catch (error) {}
  return PC_pc_producttpl_VM_Extend;
});



// WEBPACK FOOTER //
// ./src/client/business/PC/PC_pc_producttpl_VM.Extend.js